<template>
  <form name="topics" @submit.prevent="$emit('save')">
    <BLayoutExpansion title="Основное" class="my-4">
      <!--
      <v-row dense>
        <v-col sm="8" lg="6">
          <BTextField
            v-model="form.slug"
            validate="required"
            label="Код"
            :disabled="isView"
            :skeleton="skeleton"
            name="slug"
            autofocus
          />
        </v-col>
      </v-row>
      -->

      <v-row dense>
        <v-col cols="12" md="8" lg="6">
          <BTextField
            v-model="form.name"
            validate="required"
            label="Название"
            :disabled="isView"
            :skeleton="skeleton"
            name="name"
            autofocus
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" md="8" lg="6">
          <BTextField
            v-model="form.name_en"
            label="Название на английском"
            :disabled="isView"
            :skeleton="skeleton"
            name="name_en"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" md="auto">
          <v-skeleton-loader :loading="skeleton" type="sentences">
            <v-checkbox
              v-model="form.reverse_ordering"
              :disabled="isView"
              label="Обратная хронология публикаций"
              dense
              hide-details
              class="ma-0 pa-0"
              name="reverse_ordering"
            />
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="auto">
          <v-skeleton-loader :loading="skeleton" type="sentences">
            <v-row no-gutters>
              <v-checkbox
                v-model="form.is_default_topic"
                :disabled="isView"
                label="Показывать по умолчанию"
                dense
                hide-details
                class="ma-0 pa-0"
                name="is_default_topic"
              />

              <BInfo
                text="Раздел будет открыт в интерфейсе при входе в ЛК"
                class="ml-2"
              />
            </v-row>
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="auto">
          <v-skeleton-loader :loading="skeleton" type="sentences">
            <v-checkbox
              v-model="form.is_hidden"
              :disabled="isView"
              label="Скрыть"
              dense
              hide-details
              class="ma-0 pa-0"
              name="is_hidden"
            />
          </v-skeleton-loader>
        </v-col>
      </v-row>

      <v-row v-if="!isCreate" dense>
        <v-col :cols="!skeleton && 'auto'">
          <BTextField
            :value="form.slug"
            label="Код"
            :skeleton="skeleton"
            name="slug"
            disabled
          />
        </v-col>
        <v-col :cols="!skeleton && 'auto'">
          <BTextField
            :value="data.created_at | dateFormatter"
            :skeleton="skeleton"
            label="Создан"
            disabled
          />
        </v-col>

        <v-col :cols="!skeleton && 'auto'">
          <BTextField
            :value="data.updated_at | dateFormatter"
            :skeleton="skeleton"
            label="Обновлен"
            disabled
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="8" lg="6">
          <BAutocompleteTopic
            v-model="form.parent_id"
            :exclude="exclude"
            label="Родитель"
            @change="onParentSelected($event)"
          />
        </v-col>
      </v-row>
    </BLayoutExpansion>

    <BLayoutExpansion title="Дочерние элементы" class="my-4">
      <template v-for="item in form.children" class="d-flex">
        <v-card :key="item.id" class="d-flex flex-row align-center my-4">
          <v-card-text class="d-flex flex-wrap">
            <div class="text-h6  mr-4">
              ID: {{ item.id }}
            </div>
            <div class="text-h6  mr-2">
              {{ item.name }}
            </div>
          </v-card-text>
          <v-spacer />
          <v-card-actions>
            <v-icon
              color="error"
              size="32px"
              class="mr-2"
              @click="removeChild(item.id)"
              v-text="'mdi-trash-can-outline'"
            />
          </v-card-actions>
        </v-card>
      </template>
      <v-row dense>
        <v-col cols="12" md="8" lg="6">
          <BAutocompleteTopic
            ref="autocomplete"
            :exclude="exclude"
            label="Дочерний компонент"
            @change="onChildSelected($event)"
          />
        </v-col>
      </v-row>
    </BLayoutExpansion>

    <button type="submit" class="d-none" />
  </form>
</template>

<script>
import BLayoutForm from '@/components/layouts/BLayoutForm.vue'
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BTextField from '@/components/forms/BTextField.vue'
import BInfo from '@/components/common/BInfo.vue'
import BAutocompleteTopic from '@/components/forms/BAutocompleteCommon/BAutocompleteTopic.vue'

const createDefaultData = () => ({
  // id
  // slug
  // created_at
  name: '',
  name_en: '',
  reverse_ordering: false,
  is_default_topic: false,
  is_hidden: false,
  children: [],
  // parent_id: null,
  // updated_at
})

export default {
  name: 'TopicsForm',
  components: {
    BLayoutExpansion,
    BTextField,
    BInfo,
    BAutocompleteTopic,
  },
  extends: BLayoutForm,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      required: true,
      default: createDefaultData,
    },
  },
  computed: {
    exclude() {
      return [...this.form.children, this.form, { id: this.form.parent_id }]
    },
  },
  methods: {
    onChildSelected(topic) {
      this.form.children.push(topic)
    },
    removeChild(id) {
      this.form.children = this.form.children.filter((item) => item.id !== id)
    },
    onParentSelected(topic) {
      this.form.parent_id = topic.id
    },
  },
}
</script>
